module.exports = __webpack_public_path__ + "assets/img/expand-layout-1-c99c7794.png";